import {GuidedTourActions} from '../../../../actions/guidedTourActions';

export type GuidedTourReducerState = {
  scrollDimissed: boolean;
};

const defaultState: GuidedTourReducerState = {
  scrollDimissed: false,
};

export function guidedTourReducer(state: GuidedTourReducerState = defaultState, action?: any): GuidedTourReducerState {
  switch (action.type) {
    case GuidedTourActions.Scroll_Dismissed:
      return {
        ...state,
        scrollDimissed: true,
      };
    default:
      return state;
  }
}
